import { diffDays } from './lockerDay';

// The confirm panel's heading, recomputed from the selected day: it names the SIZE of the
// extension, which is the number the agent is actually deciding. Without a deadline in force there
// is nothing to extend from, so the heading names the datum being set instead of a delta. A
// non-positive delta cannot be selected (minDate is the floor) but is answered the same way rather
// than rendering «Ampliar 0 días».
// Deviation from the mockup, on purpose: there the heading tracks the day under the POINTER;
// MUI's DateCalendar exposes no hover without a custom day slot, so it tracks the SELECTED day.
// A difference of nuance, not of datum.
// TODO: i18n — copy en ES hasta Fase 1, incl. la pluralización.
export function extendCustodyHeading(
  currentExpirationDay: string | null,
  selectedDay: string,
): string {
  if (currentExpirationDay === null) return 'Nueva fecha de expiración';
  const days = diffDays(selectedDay, currentExpirationDay);
  if (days <= 0) return 'Nueva fecha de expiración';
  return days === 1 ? 'Ampliar 1 día' : `Ampliar ${days.toString()} días`;
}
